var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPpt(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.583 5h3.25a.208.208 0 00.148-.356L13.689.354a.208.208 0 00-.356.146v3.25A1.25 1.25 0 0014.583 5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.125 5.833h-3.542A2.083 2.083 0 0112.5 3.75V.207A.208.208 0 0012.292 0H3.333a1.667 1.667 0 00-1.666 1.667v16.666A1.667 1.667 0 003.333 20h13.334a1.667 1.667 0 001.666-1.667V6.04a.208.208 0 00-.208-.207zm-12.292 7.6h-.519a.21.21 0 00-.21.21v1.769a.52.52 0 01-1.042 0v-5a.52.52 0 01.521-.521h1.25a1.77 1.77 0 010 3.542zm4.167 0h-.52a.21.21 0 00-.21.21v1.769a.52.52 0 01-1.04 0v-5a.52.52 0 01.52-.521H10a1.77 1.77 0 010 3.542zm6.25-2.5h-.938a.208.208 0 00-.208.207v4.277a.52.52 0 11-1.041 0v-4.274a.208.208 0 00-.208-.207h-.938a.52.52 0 010-1.042h3.333a.52.52 0 010 1.042z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.833 10.936h-.519a.21.21 0 00-.21.21v1.038a.21.21 0 00.21.21h.52a.73.73 0 000-1.458zM10 10.936h-.52a.21.21 0 00-.21.21v1.038a.21.21 0 00.21.21H10a.73.73 0 000-1.458z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPpt);
export default __webpack_public_path__ + "static/media/ppt.716dc4a8.svg";
export { ForwardRef as ReactComponent };